import { render, staticRenderFns } from "./AdminBusinessesList.vue?vue&type=template&id=399f5a70&scoped=true"
import script from "./AdminBusinessesList.vue?vue&type=script&lang=js"
export * from "./AdminBusinessesList.vue?vue&type=script&lang=js"
import style0 from "./AdminBusinessesList.vue?vue&type=style&index=0&id=399f5a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f5a70",
  null
  
)

export default component.exports